import { render, staticRenderFns } from "./signaturePad.vue?vue&type=template&id=3674bc8e&scoped=true"
import script from "./signaturePad.vue?vue&type=script&lang=js"
export * from "./signaturePad.vue?vue&type=script&lang=js"
import style0 from "./signaturePad.vue?vue&type=style&index=0&id=3674bc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674bc8e",
  null
  
)

export default component.exports